<template>
  <div class="page">
    <el-divider></el-divider>
    <el-form ref="ruleForm">
      <el-form-item label="公司：" class="page-input" prop="companyCode">
        <el-select
          v-model="personCompanyCode"
          placeholder="请选择公司"
          @change="changeCompany"
          disabled
        >
          <el-option
            v-for="item in companyList"
            :key="item.personCompanyCode"
            :label="item.personCompanyName"
            :value="item.personCompanyCode"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-divider></el-divider>
    <el-row class="page-row">
      <el-input
        placeholder="请输入内容"
        v-model="searchValue"
        filterable
        clearable
        suffix-icon="el-icon-search"
        class="inputIcon"
      ></el-input>
      <el-button
        v-for="item in menuButtonList"
        type="primary"
        :key="item.id"
        @click="click(item.attributes.buttonUrl)"
        class="fixed-bottom-btn"
        >{{ item.label }}</el-button
      >
    </el-row>
    <el-row type="flex">
      <div class="list">
        <el-scrollbar>
          <el-tree
            ref="tree"
            :data="treeData"
            node-key="id"
            show-checkbox
            draggable
            highlight-current
            check-strictly
            :filter-node-method="filterNode"
            :allow-drop="allowDrop"
            @node-drop="handleDrop"
            @node-click="handleNodeClick"
            @check-change="handleCheckChange"
            @check="currentCheck"
            @node-expand="handleNodeExpand"
            @node-collapse="handleNodeCollapse"
            :default-expanded-keys="defaultShowNodes"
            :expand-on-click-node="false"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ data.meterNo }}</span>
              <span>
                <i
                  class="el-icon-edit"
                  style="padding-left: 8px"
                  @click="() => edit(node, data)"
                ></i>
                <i
                  class="el-icon-remove-outline"
                  style="padding-left: 8px"
                  @click="() => remove(node, data)"
                ></i>
                <template v-if="data.meterType != '4'">
                  <i
                    class="el-icon-circle-plus-outline"
                    style="padding-left: 8px"
                    @click="() => append(data)"
                  ></i>
                </template>
              </span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
      <MeterInformationCard
        v-if="showMeterData.id != ''"
        :key="timer"
        :showMeterData="showMeterData"
      >
      </MeterInformationCard>
    </el-row>
    <AddTransformerDialog
      :showDialog="showAddTransformerDialog"
      :transformerDialogType="transformerDialogType"
      :meterNo="id"
      :meterType="meterType"
      :companyCode="personCompanyCode"
      @closeDialog="showAddTransformerDialog = false"
      @submit="addTransformer($event)"
    >
    </AddTransformerDialog>
    <!--批量上传 -->
    <SiruiUpload
      ref="siruiUpload"
      :isShowDownTemplateBtn="true"
      @getData="querySpaceTree"
      :action="action"
      :data="importData"
    />
  </div>
</template>
<script>
  import MeterInformationCard from '../meter/components/meterInformationCard.vue';
  import AddTransformerDialog from '../meter/components/addTransformerDialog.vue';
  import SiruiUpload from '@/components/SiruiUpload';
  import MeterAPI from '@/api/property/meterManagement';
  export default {
    name: 'Meter',
    components: {
      MeterInformationCard,
      AddTransformerDialog,
      SiruiUpload,
    },
    computed: {
      //导入额外参数
      importData() {
        return {
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          belongTenantCode: this.userInfo.tenantCode,
          dataGroup: this.$globalVar.dataGroup,
          access_token: this.userInfo.access_token,
        };
      },
    },
    data() {
      return {
        formRules: {
          name: [{ message: '请输入片区名称', readonly: false }],
        },
        ids: [], // 选中数组
        showAddTransformerDialog: false,
        transformerDialogType: 'add',
        meterType: '1',
        meterNo: '',
        parentId: '',
        meterDetail: {},
        menuButtonList: [],
        id: '',
        timer: '', //子组件刷新
        showAddAreaDilaog: false,
        showAddUnitDialog: false,
        informationTitle: '编译器',
        treeData: [],
        page: { pages: 10, pageSize: 10, total: 100 },
        companyList: [], //公司数组
        searchValue: '',
        load: false,
        action: MeterAPI.METER_IMPORT,
        personCompanyCode: '',
        changeIdList: [],
        showMeterData: {
          type: '1', //显示类型
          id: '', //点击的id
          children: [], //对应的子tree
        },
        defaultShowNodes: [],
      };
    },
    mounted() {
      this.getCompany();
      this.getButtonList();
    },
    methods: {
      // 树节点展开
      handleNodeExpand(data) {
        // 保存当前展开的节点
        let flag = false;
        this.defaultShowNodes.some((item) => {
          if (item === data.id) {
            // 判断当前节点是否存在， 存在不做处理
            flag = true;
            return true;
          }
        });
        if (!flag) {
          // 不存在则存到数组里
          this.defaultShowNodes.push(data.id);
        }
      },
      // 树节点关闭
      handleNodeCollapse(data) {
        this.defaultShowNodes.some((item, i) => {
          if (item === data.id) {
            // 删除关闭节点
            this.defaultShowNodes.length = i;
          }
        });
      },
      allowDrop(draggingNode, dropNode, type) {
        if (draggingNode.data.parentId == dropNode.data.id) {
          return type == 'inner';
        } else if (draggingNode.data.parentId == dropNode.data.parentId) {
          return type != 'inner';
        } else {
          return false;
        }
      },
      handleDrop(draggingNode) {
        this.changeIdList = [];
        if (draggingNode.data.parentId == null) {
          this.changeIdList = this.treeData.map((item) => item.id);
        } else {
          this.changeSort(draggingNode.data.parentId, this.treeData);
        }
        this.updateSort();
      },
      changeSort(id, data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].id == id) {
            this.changeIdList = data[i].children.map((item) => item.id);
          } else {
            if (data[i].children.length > 0) {
              this.changeSort(id, data[i].children);
            }
          }
        }
      },
      async updateSort() {
        const { data } = await this.$axios.post(MeterAPI.UPDATE_SORT, {
          type: 'electric',
          ids: this.changeIdList,
        });
        if (data.code == 0) {
          console.log('排序成功');
        } else {
          this.$message.error(data.msg);
        }
      },

      // 编辑
      edit(node, data) {
        if (data.effectiveStatus == '2') {
          this.$message.warning('生效中电表不支持编辑,请选择正确的数据!');
        } else if (data.auditStatus == '2') {
          this.$message.warning('待审核电表不支持编辑,请选择正确数据!');
        } else {
          this.transformerDialogType = 'edit';
          this.meterType = data.meterType;
          this.meterNo = data.meterNo;
          this.parentId = data.parentId;
          this.id = data.id;
          this.meterDetail = data;
          this.showAddTransformerDialog = true;
        }
      },
      // 新建
      append(data) {
        this.meterType = data.meterType - 0 + 1 + '';
        this.transformerDialogType = 'add';
        this.parentId = data.id;
        this.meterDetail = data;
        this.showAddTransformerDialog = true;
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.meterNo.indexOf(value) !== -1;
      },
      add() {
        this.transformerDialogType = 'add';
        this.parentId = '';
        this.meterType = '1';
        this.showAddTransformerDialog = true;
      },
      // 选择树状结构
      handleNodeClick(data) {
        this.showMeterData.type = data.meterType;
        this.showMeterData.id = data.id;
        this.showMeterData.children = data.children;
      },
      // 当前选中的节点
      currentCheck(data, checkData) {
        this.ids = checkData.checkedNodes;
      },
      click(type) {
        this[type]();
      },

      /******************   数据请求  ******************************* */

      //获取公司信息
      async getCompany() {
        const { data } = await this.$axios.post(MeterAPI.GET_LIST_PERSON, {
          id: this.userInfo.userCode,
        });
        if (data.code == 0) {
          this.companyList = data.data.personCompanyInfo;
          this.personCompanyCode = this.userInfo.companyCode;
        }
      },
      //获取tree
      async querySpaceTree() {
        const { data } = await this.$axios.post(MeterAPI.ELECTRIC_METER, {
          companyCode: this.personCompanyCode,
        });
        if (data.code == 0) {
          this.treeData = data.data;
          if (this.treeData != null && this.treeData.length > 0) {
            if (this.showMeterData.id == '') {
              this.showMeterData.id = this.treeData[0].id;
              this.showMeterData.type = this.treeData[0].meterType;
              this.meterNo = this.treeData[0].meterNo;
            }
          }
        }
      },
      // 添加电表
      async addTransformer(formData) {
        var list = this.companyList.filter(
          (item) => item.personCompanyCode == this.personCompanyCode
        );
        let params = {
          ...formData,
          id: this.transformerDialogType == 'edit' ? this.id : '',
          companyCode: this.personCompanyCode,
          companyName: list[0].personCompanyName,
          parentId: this.parentId,
          // spaceId: data.spaceId != '' ? data.spaceId : this.meterDetail.spaceId,
          // spaceName: data.spaceName != '' ? data.spaceName : this.meterDetail.spaceName, //片区
          // areaName: data.areaName != '' ? data.areaName : this.meterDetail.areaName,
          // line: data.line != '' ? data.line : this.meterDetail.line,
        };
        const { data } = await this.$axios.post(
          this.transformerDialogType == 'edit' ? MeterAPI.METER_UPDATA : MeterAPI.ADD_METER,
          params
        );
        if (data.code == 0) {
          this.$message.success('操作成功');
          if (this.transformerDialogType == 'edit') {
            this.timer = new Date().getTime();
          }
          this.querySpaceTree();
          this.showAddTransformerDialog = false;
        } else {
          if (data.msg != '') {
            return this.$message.error(data.msg);
          }
          this.$message.success('操作失败');
        }
      },
      // 移除
      async remove(node, item) {
        if (item.effectiveStatus == '2' || item.effectiveStatus == '3') {
          this.$message.warning('该电表非“待生效”状态,不可删除!');
        } else {
          this.$confirmAction('', '您确定要删除吗？')
            .then(async () => {
              const { data } = await this.$axios.delete(`${MeterAPI.ELECTRIC_METER}/${item.id}`);
              if (data.code == 0) {
                this.$message.success('删除成功');
                if (item.id == this.showMeterData.id) {
                  this.showMeterData.id = '';
                }
                this.querySpaceTree();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch((e) => {
              console.log(e);
            });
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      // 改变公司
      changeCompany(value) {
        this.personCompanyCode = value;
      },
      // 失效处理
      invalid() {
        if (this.ids.length == 0) {
          this.$message.warning('请选择数据');
        } else {
          let index = this.ids.findIndex(
            (item) => item.effectiveStatus == '1' || item.effectiveStatus == '3'
          );

          if (index != -1) {
            this.$message({
              type: 'warning',
              message: '请选择正确的数据！',
            });
          } else {
            var message = '';
            var confirmMessage = '您确定要失效吗？';
            this.ids.some((item) => {
              if (item.relationSpace) {
                message = '能耗表与空间进行了关联，请先解除关联再失效！';
                return true;
              }
              if (item.children != null && item.children.length > 0) {
                confirmMessage = '您选择的电表下关联了子表，确认要失效吗？';
                return true;
              }
            });
            if (message != '') {
              // return this.$message.warning(message);
              return this.$confirm(message, '', {
                confirmButtonText: '确定',
                type: 'warning',
                showCancelButton: false,
                center: true,
              });
            }
            this.$confirmAction('', confirmMessage)
              .then(async () => {
                let idList = this.ids.map((item) => item.id);
                const { data } = await this.$axios.post(MeterAPI.METER_LAPSE, idList);
                if (data.code == 0) {
                  this.$message.success('操作成功');
                  this.timer = new Date().getTime();
                  this.querySpaceTree();
                } else {
                  if (data.msg != '') {
                    return this.$message.error(data.msg);
                  }
                  this.$message.error('操作失败');
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
        }
      },
      //提交审核
      async submit() {
        if (this.ids.length == 0) {
          this.$message.warning('请选择数据');
        } else {
          let index = this.ids.findIndex(
            (item) => item.effectiveStatus == '2' || item.effectiveStatus == '3'
          );
          if (index != -1) {
            this.$message({
              type: 'warning',
              message: '请选择正确的数据',
            });
          } else {
            let idList = this.ids.map((item) => item.id);
            const { data } = await this.$axios.post(MeterAPI.METER_BATCHSUBMIT, idList);
            if (data.code == 0) {
              this.$message.success('提交审核成功!');
              this.timer = new Date().getTime();
              this.querySpaceTree();
            } else {
              if (data.msg != '') {
                return this.$message.error(data.msg);
              }
              this.$message.error('提交审核失败!');
            }
          }
        }
      },
      // 批量导入
      import() {
        this.$refs.siruiUpload.openDialog(true, '07');
      },
      handleCheckChange(data, checked, indeterminate) {
        console.log('输出了', data, checked, indeterminate);
        if (data.children != null) {
          this.setChecked(data.children, checked);
        }
      },
      setChecked(data, checked) {
        for (let i = 0; i < data.length; i++) {
          this.$refs.tree.setChecked(data[i].id, checked, false);
          if (data[i].children != null) {
            this.setChecked(data[i].children, checked);
          }
        }
      },
    },

    watch: {
      searchValue(val) {
        this.$refs.tree.filter(val);
      },
      personCompanyCode() {
        //公司更换重新请求树状 数据
        this.querySpaceTree();
      },
    },
  };
</script>
<style scoped lang="scss">
  .page {
    background-color: white;
    margin-top: 0px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 20px;
    height: 100%;
    top: 0;

    .page-input {
      padding-top: 15px;
      padding-left: 20px;
      padding-bottom: 15px;
    }

    .el-divider--horizontal {
      display: block;
      height: 0.5px;
      width: 100%;
      margin: 1px 0;
    }

    .page-row {
      margin-top: 15px;
      padding-top: 15px;
      padding-bottom: 15px;
      background-color: #f6f7f9;
      //margin-bottom: 10px;
    }

    .inputIcon {
      padding-left: 10px;
      width: 300px;
    }

    .el-input__icon {
      height: 100%;
      width: 25px;
      text-align: right;
      transition: all 0.3s;
      line-height: 40px;
    }

    .fixed-bottom-btn {
      border-radius: 2px;
      height: 32px;
      min-width: 80px;
      font-size: 12px;
      margin-left: 10px;
    }

    .list {
      max-width: 300px;
      min-width: 300px;
      height: 420px;
      overflow: auto;
    }

    .custom-tree-node {
      font-size: 14px;
      padding-right: 8px;
    }

    ::v-deep .el-tree {
      background-color: #f6f7f9;
      height: 100%;
      display: inline-block;
    }

    ::v-deep .el-tree__empty-block {
      width: 300px;
    }

    .el-pagination {
      margin-top: 20px;
    }
  }

  ::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #66b1ff;
    color: white;
  }
</style>
